/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BagBriefcaseIcon24Solid = forwardRef('BagBriefcaseIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.563 2A2.562 2.562 0 0 0 7 4.563V6H4a2 2 0 0 0-2 2v2.551l9.354 2.805a2.25 2.25 0 0 0 1.293 0l9.352-2.805.001-.055V8a2 2 0 0 0-2-2h-3V4.562A2.563 2.563 0 0 0 14.437 2H9.564ZM15 6V4.562A.562.562 0 0 0 14.437 4H9.564A.563.563 0 0 0 9 4.563V6h6Z" }),
        React.createElement("path", { d: "M3 17.5v-5.084l7.922 2.377a3.75 3.75 0 0 0 2.155 0L21 12.416V17.5a3.5 3.5 0 0 1-3.5 3.5h-11A3.5 3.5 0 0 1 3 17.5Z" })));
});
